import { Link, Outlet } from "react-router-dom";
import Header from "./Header";
import { HelpChat } from "@/components/common/HelpChat";
import { LOGO_URL } from "@/constants/network";
import { NetworkDisclosure, TEST_TOKEN_NOTE } from "@/components/common/TestTokenNote";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 relative z-10">
        <Outlet />
      </main>
      <footer className="border-t border-white/5 bg-[#050505]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <img src={LOGO_URL} alt="FSC" className="w-6 h-6 rounded-full" />
              <span className="font-display font-semibold text-sm text-white">
                FMI Smart Chain Hub
              </span>
            </div>
            <div className="flex items-center gap-4 text-xs">
              <Link to="/privacy" data-testid="footer-privacy-link" className="text-zinc-400 hover:text-[#D4AF37] transition-colors">Privacy</Link>
              <Link to="/terms" data-testid="footer-terms-link" className="text-zinc-400 hover:text-[#D4AF37] transition-colors">Terms</Link>
              <Link to="/admin" data-testid="footer-admin-link" className="text-zinc-400 hover:text-[#D4AF37] transition-colors">Admin</Link>
              <p className="text-zinc-500">Chain ID 77177 &middot; FMI Smart Chain &middot; EVM Compatible</p>
            </div>
          </div>
          <div className="mt-4 pt-4 border-t border-white/5">
            <p data-testid="footer-test-token-note" className="text-xs text-zinc-500 mb-1">{TEST_TOKEN_NOTE}</p>
            <NetworkDisclosure testId="footer-network-disclosure" />
          </div>
        </div>
      </footer>
      <HelpChat />
    </div>
  );
}
